module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-34534874-1","head":false,"defer":true},
    },{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-axe/gatsby-browser.js'),
      options: {"plugins":[],"showInProduction":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Katanya","short_name":"Katanya","description":"Boutique international consultancy providing strategy, transformation and management services that align your digital efforts with your business strategy.","start_url":"/","background_color":"#fff","theme_color":"#00AFBD","display":"minimal-ui","icon":"src/images/icon.png","icons":[{"src":"icons/favicon-16x16.png","sizes":"16x16","type":"image/png"},{"src":"icons/favicon-32x32.png","sizes":"16x16","type":"image/png"},{"src":"icons/android-chrome-96x96.png","sizes":"96x96","type":"image/png"},{"src":"icons/icon_512x512.png","sizes":"512x512","types":"image/png"},{"src":"icons/icon_192x192.png","sizes":"192x192","types":"image/png"}],"cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"61f5fb30e529c04698852650c9fa1f2d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
